










import Vue from 'vue';

export default Vue.extend({
  name: 'LayoutBreadcrumbs',
  computed: {
    routeName(): string {
      return this.$route.name ?? '';
    },
  },
});
